var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 653,
    height: 226,
    viewBox: "0 0 653 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7 62C72.8208 62 86.6999 48.1208 86.6999 31C86.6999 13.8792 72.8208 0 55.7 0C38.5791 0 24.7 13.8792 24.7 31C24.7 48.1208 38.5791 62 55.7 62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M568 29.2H515.3L452.7 179.7H349.3V148.3H442.6V105.7H348.6V77.7H451.3V29.2H296V83C296 83 289.7 64 266.7 48.3C243.7 32.6 229.4 29.2 200.7 29.2H121.3V199H95C92.0826 199 89.2847 197.841 87.2218 195.778C85.1589 193.715 84 190.917 84 188V80H0V106.3H19.3C22.4826 106.3 25.5348 107.564 27.7853 109.815C30.0357 112.065 31.3 115.117 31.3 118.3V183C31.3 187.243 29.6143 191.313 26.6137 194.314C23.6131 197.314 19.5435 199 15.3 199H0V225.7H197.3C233.3 225.7 246 219 262 209C278 199 295.3 175 295.3 175V225.7H491.3L504.6 192.4H580L592.7 225.7H652.7L568 29.2ZM200 177.7H176V79H208C220.7 79 250.7 94.3 250.7 128.3C250.7 162.3 228 177.7 200 177.7ZM520.7 148.4L542.7 93.7L563.4 148.4H520.7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.59358e077f13f5d3deefaa228b2664b0.svg";
export { ForwardRef as ReactComponent };